import {useSelector} from 'react-redux';
import {useRouter} from '@/common/services/router';
import {selectDomainConfig} from '@/app/store/config/selectors';
import {useLocalizer} from '@/common/services/localizer';
import {urlParamsBuilder, AnyParamsSchema} from './urlParamsBuilder';

/**
 * The hook is an add-on over an abstract urlGenerator that provides a function for generating urls based on
 * typed parameters and also takes into consider the specifics of service url construction
 */
export function useUrlBuilder() {
	const {urlGenerator} = useRouter();
	const {primaryLanguage, routeKeywords} = useSelector(selectDomainConfig);
	const currentLanguage = useLocalizer().language;

	return <N extends AnyParamsSchema['name']>(routeName: N, params: Extract<AnyParamsSchema, {name: N}>['params']) => {
		const language = currentLanguage !== primaryLanguage ? currentLanguage : undefined;
		const totalParams = urlParamsBuilder<N>(routeKeywords, routeName, params as any, language);
		return urlGenerator(routeName, totalParams as Record<string, string>);
	};
}

useUrlBuilder.disaplayName = 'useUrlBuilder';
